export default __webpack_public_path__ + "static/SD_Orange_Stripe-930e4ef6002938d25d2ac144ecde0be0.jpg";